module.exports = [
    {
        "date": "2024-07-18",
        "title": "the little prince",
        "author": "antoine de saint-exupéry",
        "year": 1943,
        "card": "20240718_01"
    },
    {
        "date": "2024-08-08",
        "title": "chunking express",
        "author": "wong kar wai",
        "year": 1994,
        "card": "20240808_02"
    },
    {
        "date": "2024-08-15",
        "title": "color of pomegranates",
        "author": "parajanov",
        "year": 1969,
        "card": "20240815_03"
    },
    {
        "date": "2024-08-22",
        "title": "god of small things",
        "author": "roy",
        "year": 1997,
        "card": "20240822_04"
    },
    {
        "date": "2024-08-29",
        "title": "stalker",
        "author": "tarkovsky",
        "year": 1979,
        "card": "20240829_05"
    },
    {
        "date": "2024-09-06",
        "title": "heart of darkness",
        "author": "joseph conrad",
        "year": 1899,
        "card": "20240906_06"
    },
    {
        "date": "2024-09-13",
        "title": "apocolypse now",
        "author": "francis ford coppola",
        "year": 1979,
        "card": "20240913_07"
    },
    {
        "date": "2024-09-20",
        "title": "hearts of darkness: a filmmaker's apocalypse",
        "author": "eleanor coppola",
        "year": 1991,
        "card": "20240920_08"
    },
    {
        "date": "2024-09-27",
        "title": "citizen kane",
        "author": "orson welles",
        "year": 1941,
        "card": "20240927_09"
    },
    {
        "date": "2024-10-04",
        "title": "the battle of algiers",
        "author": "pontecorvo",
        "year": 1966,
        "card": "20241004_10"
    },
    {
        "date": "2024-10-11",
        "title": "small things like these",
        "author": "keegan",
        "year": 2021,
        "card": "20241011_11"
    },
    {
        "date": "2024-10-18",
        "title": "la notte",
        "author": "antonioni",
        "year": 1979,
        "card": "20241018_12"
    },
    {
        "date": "2024-10-21",
        "card": "20241021_13"
    },
    {
        "date": "2024-11-01",
        "card": "20241101_14"
    },    
    {
        "date": "2024-11-08",
        "card": "20241108_15"
    },    
    {
        "date": "2024-11-15",
        "card": "20241115_16"
    },
    {
        "date": "2024-11-22",
        "card": "20241122_17"
    },
    {
        "date": "2024-11-29",
        "card": "20241129_18"
    },
    {
        "date": "2024-12-06",
        "card": "20241206_19"
    },
    {
        "date": "2024-12-13",
        "card": "20241213_20"
    },
    {
        "date": "2025-01-10",
        "card": "20250110_21"
    },
    {
        "date": "2025-01-17",
        "card": "20250117_22"
    },
    {
        "date": "2025-01-23",
        "card": "20250123_23"
    },
    {
        "date": "2025-01-31",
        "card": "20250131_24"
    },
    {
        "date": "2025-02-06",
        "card": "20250206_25"
    },
    {
        "date": "2025-02-13",
        "card": "20250213_26"
    },
    {
        "date": "2025-02-20",
        "card": "20250220_27"
    },
    {
        "date": "2025-03-21",
        "card": "20250321_28"
    },
    {
        "date": "2025-03-28",
        "card": "20250328_29"
    },
    {
        "date": "2025-04-04",
        "card": "20250404_30"
    },
    {
        "date": "2025-04-11",
        "card": "20250411_31"
    },
    {
        "date": "2025-04-18",
        "card": "20250418_32"
    },
    {
        "date": "2025-04-25",
        "card": "20250425_33"
    },
    {
        "date": "2025-05-02",
        "card": "20250502_34"
    },
    {
        "date": "2025-05-09",
        "card": "20250509_35"
    },
    {
        "date": "2025-06-14",
        "card": "20250614_36"
    },
    {
        "date": "2025-08-25",
        "card": "20250825_37"
    },
    {
        "date": "2025-10-10",
        "card": "20251010_38"
    },
    {
        "date": "2025-10-17",
        "card": "20251017_39"
    },
    {
        "date": "2025-10-30",
        "card": "20251030_40"
    },
    {
        "date": "2025-11-07",
        "card": "20251107_41"
    },
    {
        "date": "2025-11-14",
        "card": "20251114_42"
    },
    {
        "date": "2025-11-21",
        "card": "20251121_43"
    },
    {
        "date": "2025-12-19",
        "card": "20251219_44"
    },
    {
        "date": "2026-01-16",
        "card": "20260116_45"
    },
    {
        "date": "2026-01-23",
        "card": "20260123_46"
    },
    {
        "date": "2026-02-13",
        "card": "20260213_47"
    },
    {
        "date": "2026-02-20",
        "card": "20260220_48"
    }
];